module.exports = __webpack_public_path__ + "img/spitter-run-mask.bb71882e.png";